import InfoButton from 'components/InfoButton/InfoButton';

export default InfoButton;
